export default __webpack_public_path__ + "static/media/coresanscr35it-webfont.96b9b6af.woff2";